define(['underscore',
    'edge/quoteandbind/common/config/FlowConfig',
    'edge/quoteandbind/pa/config/FlowConfig',
    'edge/quoteandbind/common/models/Submission'
], (_, commonSubFlowDefnFactories, paFlowDefnFactory, Submission) => {

    return ($q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams)=> {

        const ACTIONS = {

            proceedToFullQuote: ({quotedSubmission}) => {

                const paFullQuoteFlowDefn = function (step, junction, flow) {
                    const commonSubFlowDefns = commonSubFlowDefnFactories(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
                    const quoteFlow = flow(commonSubFlowDefns.quote);
                    const bindFlow = flow(commonSubFlowDefns.bindAndPay);

                    const paFlowDefn = paFlowDefnFactory(AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx);
                    const paContactDetailsFlow = flow(paFlowDefn.contactDetails);
                    const paCoverablesFlow = flow(paFlowDefn.coverables);
                    const paMoreInfoFlow = flow(paFlowDefn.moreInfo);

                    flow(commonSubFlowDefns.globalExits);
                    step(paContactDetailsFlow.entry, true);
                    paContactDetailsFlow.exits.paContactDetailsComplete.onNext.goTo(paCoverablesFlow.entry);
                    paCoverablesFlow.exits.paCoverablesComplete.onNext.goTo(quoteFlow.entry);
                    quoteFlow.exits.offeringSelected.onNext.goTo(paMoreInfoFlow.entry);
                    paMoreInfoFlow.exits.paMoreInfoComplete.onNext.goTo(bindFlow.entry);
                };

                const stepToStateMapping = {
                    returnHome: () => ['zipCode'],
                    confirmation: (model) => ['qnbconfirmation', {
                        quoteSummary: model.value,
                        returnStateInfo: ['zipCode']
                    }],
                    error: (model, args) => ['contactUs', {
                        quoteID: (model.quoteID) ? model.quoteID.value : '',
                        errorMsg: args.errorMsg
                    }]
                };

                const parentWizardState = 'baseQnbWizard';
                const flowfactory = wizardFlowService(paFullQuoteFlowDefn, parentWizardState, stepToStateMapping);

                quotedSubmission.bindData = undefined;
                quotedSubmission.quoteData = undefined;
                quotedSubmission = new Submission(quotedSubmission);
                const submissionModel = ViewModelService.create(quotedSubmission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', ViewModelCtx);
                flowfactory.start(submissionModel, $stateParams);

                //doesn't matter what we return here as long as it's a promise, starting a new wizard flow moves to a new page
                return $q.resolve();
            }
        };


        return function (step, junction) {
            step('vehicles', true)
                .onNext.goTo('address');

            step('address')
                .onNext.goTo('additional');

            step('additional')
                .onNext.goTo('quote');

            step('quote')
                .onNext.doAction(ACTIONS.proceedToFullQuote).thenGoTo('exit', 'vehicles');

            junction('exit');

        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/config/FlowConfig.js
 **/